import React from "react";
import Services from "../../Pages/Services/Services";
import Banner from "../Banner/Banner";
import CarRepairEngineer from "../CarRepairEngineer/CarRepairEngineer";

const Home = () => {
  return (
    <>
      <Banner />
      <Services />
      <CarRepairEngineer />
    </>
  );
};

export default Home;
